import React from 'react'
import { Col, Row } from 'antd'
import Image from 'next/image'

import Wrapper from 'components/Wrapper/Wrapper'

import BookCTAs from '../BookCTAs/BookCTAs'
import ReviewRating from '../ReviewRating/ReviewRating'
import { ActionBarProps } from '../type'

import styles from './ActionBar.module.css'

const ActionBar: React.FC<ActionBarProps> = ({
  profile,
  loading,
  products,
  onClick,
}) => {
  if (!profile) return null

  return (
    <section className={styles.base}>
      <Wrapper data-cy="profileActionBar">
        <Row align="middle" gutter={[8, 16]}>
          <Col xs={24}>
            {!loading ? (
              <div className={styles.meta}>
                <div className={styles.profileInfo}>
                  <div className={styles.profilePicture}>
                    <Image
                      src={
                        profile?.profilePicture?.avatarUrl ||
                        profile.profilePicture?.cardUrl
                      }
                      alt="Profile Picture"
                      layout="fill"
                    />
                  </div>
                  <div className={styles.profileName}>{profile.name}</div>
                </div>

                <ReviewRating
                  rating={profile.averageReviewRating}
                  showReviewText={false}
                />
              </div>
            ) : (
              <div className={styles.profileActionBarTopFiller} />
            )}
          </Col>

          <Col xs={24} style={{ paddingBottom: 16 }}>
            <BookCTAs
              onButtonClick={onClick}
              products={products}
              profile={profile}
              discountBadgeColor={null}
            />
          </Col>
        </Row>
      </Wrapper>
    </section>
  )
}

export default ActionBar
